module.exports = __webpack_public_path__ + "media/src/assets/icons/ico-blank-823cbdd876af6346f80b5cd58b2b1a89.svg";